module.exports = __webpack_public_path__ + "assets/img/experts.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/experts.svg
// module id = 1980
// module chunks = 0